import styles from './SkeletonLoader.module.css';
import { clsx } from 'clsx';

import { type FlexProps, Flex } from '@repo/ui/Flex';
import { useIsMobile } from '@repo/lib/hooks/useMediaQuery';

type LayoutItem = {
  columns?: number;
  rows?: number;
  startColumn?: number;
  startRow?: number;
  height?: number;
};

type Layout = {
  repeat?: number;
  items: {
    default: LayoutItem[];
    mobile?: LayoutItem[];
  };
};

type SkeletonLoaderProps = {
  layout: Layout;
  itemHeight?: number;
} & Partial<FlexProps>;

export const SkeletonLoader = ({
  layout,
  padding = 'p-16',
  direction = 'column',
  gap = 'g-16',
  itemHeight = 20,
  className,
}: SkeletonLoaderProps) => {
  const { items, repeat } = layout;
  const isMobile = useIsMobile();

  const layoutItems = isMobile && items.mobile ? items.mobile : items.default;

  return (
    <Flex
      padding={padding}
      direction={direction}
      gap={gap}
      className={className}
    >
      {Array.from({ length: repeat ?? 1 }).map((_, index) => (
        <Flex className={clsx([styles.itemGrid])} key={index}>
          {layoutItems.map((item, index) => (
            <div
              key={index}
              className={styles.skeletonButton}
              style={{
                gridColumn: `${item.startColumn ?? 1} / span ${item.columns ?? 1}`,
                gridRow: `${item.startRow ?? 1} / span ${item.rows ?? 1}`,
                height: item.height || itemHeight,
              }}
            />
          ))}
        </Flex>
      ))}
    </Flex>
  );
};
